import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatCurrency } from '../../utils/formatters';

const DashboardChart = ({ products }) => {
  // Process data for chart (example: products by price range)
  const data = [
    { name: 'Under $100', value: products?.filter(p => p.price < 100).length || 0 },
    { name: '$100-$300', value: products?.filter(p => p.price >= 100 && p.price < 300).length || 0 },
    { name: '$300-$500', value: products?.filter(p => p.price >= 300 && p.price < 500).length || 0 },
    { name: '$500-$1000', value: products?.filter(p => p.price >= 500 && p.price < 1000).length || 0 },
    { name: 'Over $1000', value: products?.filter(p => p.price >= 1000).length || 0 },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-4 shadow-lg rounded-lg border">
          <p className="text-sm font-medium">{label}</p>
          <p className="text-sm text-gray-600">
            Products: <span className="font-bold text-primary-600">{payload[0].value}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card h-80">
      <h3 className="text-lg font-semibold mb-4">Products by Price Range</h3>
      <ResponsiveContainer width="100%" height="85%">
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="name" stroke="#6b7280" />
          <YAxis stroke="#6b7280" />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#3b82f6"
            fillOpacity={1}
            fill="url(#colorValue)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashboardChart;